import styled from '@emotion/styled';
import vars from '@variables';
import Glider from 'react-glider';

export const StyledArrowButton = styled.button<{
  direction: 'left' | 'right';
  top?: string;
}>`
  color: ${vars.white};
  width: 40px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-block: 0;
  padding-inline: 0;
  border: none;
  cursor: pointer;
  background-color: #fff;
  border-radius: 2px;
  position: absolute;
  top: ${({ top }) => top || '30%'};
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);

  ${props =>
    props.direction === 'left' &&
    `
    left: 0;
  `}

  ${props =>
    props.direction === 'right' &&
    `
    right: 0;
  `}

  @media screen and (max-width: ${vars.breakPointTablet}) {
    display: none;
  }
`;

export const StyledGlider = styled(Glider)`
  .glider-track {
    gap: 18px;
    overflow: hidden;
  }

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledCarouselItem = styled.div`
  width: 100%;
  display: flex;
  align-items: start;
`;

export const CarouselContainer = styled.div`
  width: 100%;
  position: relative;

  .disabled {
    display: none;
  }
`;
